import React, { useEffect, useRef, useState } from 'react'
import './MultiselectDropdown.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import Button from '../Button/Button';
import { Option } from '../Dropdown/Dropdown';
import { useReadOnly } from '../../../utils/ReadOnlyContext';

export interface MultiselectDropdownProps {
    id?: string;
    placeholder?: string;
    name: string;
    options: Option[]
    categoryName: string;
    search?: boolean;
    selectedOptions: string[];
    setSelectedOptions: (updatedSelection: string[]) => void;
    checkAll?: boolean;
    uncheckAll?: boolean;
    maxSelectedOptions?: number;
    preventDefault?: boolean;
    enabledInReadonly?: boolean;
}

function MultiselectDropdown(props: MultiselectDropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null)
    const { isReadOnly } = useReadOnly()

    const handleOptionToggle = (value: string) => {
        const updated = props.selectedOptions.includes(value) ? props.selectedOptions.filter((option) => option !== value) : [...props.selectedOptions, value]
        props.setSelectedOptions(updated)
    }

    useEffect(() => {
        const outsideClick = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        };

        document.addEventListener('mousedown', outsideClick);
        return () => {
            document.removeEventListener('mousedown', outsideClick)
        }
    }, [])

    useEffect(() => {
        if (!isOpen && search !== '') {
            setSearch('')
        }
    }, [isOpen, search])

    const filteredOptions = props.options.filter(option => {
        return option.text?.toLowerCase().includes(search.toLowerCase())
    })

    const isOptionSelected = (option: Option) => {
        return props.selectedOptions.includes(option.value as string)
    }

    const isOptionDisabled = (option: Option) => {
        if (props.maxSelectedOptions && props.selectedOptions.length === props.maxSelectedOptions && !isOptionSelected(option)) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className='multiselect-dropdown' ref={dropdownRef}>
            <div className={'multiselect-dropdown-header' + ((isReadOnly && !props.enabledInReadonly) ? " disabled" : "")} onClick={() => setIsOpen(!isOpen)}>
                {props.placeholder !== undefined && props.selectedOptions.length === 0 ? props.placeholder : props.selectedOptions.length + " " + props.categoryName.toUpperCase() + "(S) SELECTED"}
            </div>
            {(isOpen && (!isReadOnly || (isReadOnly && props.enabledInReadonly))) && (
                <div className='multiselect-dropdown-list'>
                    <div className='multiselect-dropdown-controls'>
                        {props.maxSelectedOptions &&
                            <span>
                                {props.selectedOptions.length} / {props.maxSelectedOptions} checked
                            </span>
                        }
                        {props.checkAll &&
                            <Button type="secondary"
                                onClick={(e) => { props.preventDefault && e.preventDefault(); props.setSelectedOptions(props.options.map((option) => String(option.value))); }}>
                                <FontAwesomeIcon icon={faCheck} />&nbsp;Check All
                            </Button>
                        }
                        {props.uncheckAll &&
                            <Button type="secondary" onClick={(e) => { props.preventDefault && e.preventDefault(); props.setSelectedOptions([]); }}>
                                <FontAwesomeIcon icon={faXmark} />&nbsp;Uncheck All
                            </Button>
                        }
                        {props.search && <input
                            placeholder='Search...'
                            type='text'
                            id='dropdown-search'
                            name='dropdown-search'
                            onChange={(e) => setSearch((e.target as HTMLInputElement).value)}></input>}
                    </div>
                    {
                        filteredOptions.map((option, index) => (
                            <Button disabled={isOptionDisabled(option)} type={isOptionDisabled(option) ? "disabled" : "secondary"}
                                onClick={(e) => { props.preventDefault && e.preventDefault(); handleOptionToggle(String(option.value)); }}
                                className={isOptionSelected(option) ? 'multiselect-dropdown-option-active' : 'multiselect-dropdown-option'}
                                key={index}>
                                {isOptionSelected(option) && <><FontAwesomeIcon icon={faCheck} />&nbsp;</>}
                                {option.text}
                            </Button>
                        ))
                    }
                </div >
            )
            }
        </div >
    )
}

export default MultiselectDropdown